// Definitions for things needed by both importing and exporting.

export let LOINC_URI = 'http://loinc.org';
